import { ApiClient } from '@webapp/core/services/ApiClient'
import { AccountRepository } from './AccountRepository'

export const accountRepository = new AccountRepository({
  httpClient: ApiClient,
})
